export default __webpack_public_path__ + "b6025571455dbf49cea4cf215941bd4d.png";